import { ReactComponent as AngleDown } from './angle-down.svg';
import { ReactComponent as AngleLeft } from './angle-left.svg';
import { ReactComponent as Bars } from './bars-solid.svg';
import { ReactComponent as ChartBar } from './chart-bar-solid.svg';
import { ReactComponent as CheckCircle } from './check-circle.svg';
import { ReactComponent as Comment } from './comment-solid.svg';
import { ReactComponent as EnvelopeOpenText } from './envelope-open-text.svg';
import { ReactComponent as ExclamationTriangle } from './exclamation-triangle-solid.svg';
import { ReactComponent as Home } from './home-solid.svg';
import { ReactComponent as InfoCircle } from './info-circle-solid.svg';
import { ReactComponent as Language } from './language.svg';
import { ReactComponent as LongArrowRight } from './long-arrow-alt-right.svg';
import { ReactComponent as Play } from './play-circle-solid.svg';
import { ReactComponent as Plus } from './plus.svg';
import { ReactComponent as Search } from './search.svg';
import { ReactComponent as SignOut } from './sign-out-alt.svg';
import { ReactComponent as Sort } from './sort.svg';
import { ReactComponent as SortDown } from './sort-down.svg';
import { ReactComponent as SortUp } from './sort-up.svg';
import { ReactComponent as Times } from './times.svg';
import { ReactComponent as TimesCircle } from './times-circle-solid.svg';
import { ReactComponent as User } from './user-solid.svg';

import { ReactComponent as CN } from './cn.svg';
import { ReactComponent as DE } from './de.svg';
import { ReactComponent as EN } from './en.svg';
import { ReactComponent as IN } from './in.svg';

const icons = new Map<string, React.FunctionComponent<React.SVGProps<SVGSVGElement>>>([
  ['fallback', Times],

  ['cn', CN],
  ['de', DE],
  ['en', EN],
  ['in', IN],

  ['error', TimesCircle],
  ['info', InfoCircle],
  ['notice', Comment],
  ['success', CheckCircle],
  ['warning', ExclamationTriangle],

  ['angle-down', AngleDown],
  ['angle-left', AngleLeft],
  ['bars', Bars],
  ['chart', ChartBar],
  ['check-circle', CheckCircle],
  ['envelope-open-text', EnvelopeOpenText],
  ['home', Home],
  ['language', Language],
  ['long-arrow-right', LongArrowRight],
  ['play', Play],
  ['plus', Plus],
  ['search', Search],
  ['sign-out', SignOut],
  ['sort-down', SortDown],
  ['sort-up', SortUp],
  ['sort', Sort],
  ['times', Times],
  ['user', User],
]);

export default icons;
